/* eslint-disable @typescript-eslint/no-explicit-any */
import { _FetchOptions, _HTTPMethod, _RequestDefinition } from './types'

export function _defineRequest<Response, FetchParams = void, UrlParams = void>(
  url: string,
  options?: _FetchOptions<UrlParams, FetchParams>
): _RequestDefinition<UrlParams, FetchParams, Response> {
  return {
    ...options,
    url,
    method: options?.method ?? 'GET',
    // Helper types
    response: {} as Response
  }
}

export function _buildQueryString(params: Record<string, any>): string {
  return (
    '?' +
    Object.entries(params)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&')
  )
}

// /user/:id => /user/123
export function _buildUrlWithUrlParams(
  url: string,
  params?: Record<string, any>
) {
  if (!params || !url.includes(':')) return url
  const urlParams = url.match(/:(\w+)/g)?.map((m) => m.slice(1))
  if (!urlParams) return url
  const urlParamsMap = new Map(urlParams.map((p) => [p, params[p]]))
  return url.replace(/:(\w+)/g, (m, p) => urlParamsMap.get(p) ?? m)
}

export type _getRequestDefinitionType<
  T extends _RequestDefinition<any, any, any>
> = {
  urlParams: T extends _RequestDefinition<infer U, any, any> ? U : never
  fetchParams: T extends _RequestDefinition<any, infer F, any> ? F : never
  response: T extends _RequestDefinition<any, any, infer R> ? R : never
  url: string
  method: _HTTPMethod
}
